import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/header/header';
import HeaderSubscription from '@/components/headerSubscription/header.vue';
import { Getter, Mutation } from 'vuex-class';

@Component({
  components: {
    Header,
    HeaderSubscription
    
  }
})
export default class SubscriptionBase extends Vue {

  @Getter getSubscriptionsOverlay;

  @Mutation SUBSCRIPTIONS_OVERLAY;

  get IsDashboard() {
    return this.$route.name === 'subscriptions_dashboard' 
          || this.$route.name === 'subscriptions_orders'
          || this.$route.name === 'subscriptions_history';
  }  


}